import styled from 'styled-components';
import { devices } from '../../../../juristec-ui/core/breakpoints';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 310px;
  max-width: 350px;
  & > span {
    font-size: 12px;
    color: ${({ theme }) => theme.grey};
    margin-top: 5px;
  }
  @media ${devices.phoneS} {
    min-width: auto;
  }
`;

export const InfoContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  grid-gap: 5px;
  margin-bottom: 5px;
  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid ${({ theme }) => theme.info};
    border-radius: 8px;
    background-color: ${({ theme }) => theme.info}88;
    padding: 2px 4px;
    & span {
      color: ${({ theme }) => theme.white};
      font-family: 'Roboto', arial, sans-serif;
    }
  }
`;
